import type { DeliveryReceipt } from '../types.js'
import { NotificationIcon } from './notificationIcons.js'
import { describeReceipt, RECEIPT_STATUS_CLASS } from '../delivery/deliveryText.js'

/** Receipts as a list, newest first: which message went where and whether it arrived. Staff, the worker and the admin all read this. */
export function DeliveryReceiptsList({ receipts, empty }: { receipts: readonly DeliveryReceipt[]; empty: string }) {
  if (receipts.length === 0) {
    return <p className="text-xs text-ink-mid">{empty}</p>
  }
  return (
    <ul className="divide-y divide-marine/10 rounded border border-marine/15 bg-white">
      {receipts.map((receipt) => (
        <li key={receipt.receiptId} className="flex items-center gap-2.5 px-3 py-2 text-[11px]">
          <NotificationIcon type={receipt.notificationType} size="sm" />
          <span className={`min-w-0 flex-1 ${receipt.providerOutcome?.status === 'failed' ? 'text-coral' : RECEIPT_STATUS_CLASS[receipt.status]}`}>{describeReceipt(receipt)}</span>
        </li>
      ))}
    </ul>
  )
}
